import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const Commission = lazyRouteComponent(() => import('../../pages/profile/commission'))

export const commissionRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'commission',
  component: Commission,
})
